import React from 'react'
import { useState } from 'react'
import { AiOutlineDoubleLeft } from '@react-icons/all-files/ai/AiOutlineDoubleLeft';
import { AiOutlineDoubleRight } from '@react-icons/all-files/ai/AiOutlineDoubleRight';
import Clickable from './Clickable';
import AudioAction from './design-system/audio/AudioAction';
import { useSelector } from 'react-redux';
import { getMedia } from '../store/slices/user';
import styles from './Carrousel.module.scss';


const Carrousel = ({array, size=6, className, minus, ui}) => {
    let [current, setCurrent] = useState(0)
    let {tablet, mobile, desktop, laptop} = useSelector(getMedia)

    size= ((!desktop && !laptop && !tablet) || mobile) ? Math.ceil(size / 3)  : tablet? Math.ceil(size / 2)  :  (desktop || laptop) ?  size :  Math.ceil(size / 3)
    size = size > 1 && minus ? size - 1 : size
  const packageCards = className?.split(' ').includes('whitePacks')

  return <div className={`carrousel ${packageCards ? styles.packageCards : ''} ${className || ''}`.trim()}>

   {size < array?.length && (ui === 'v2'
     ? <AudioAction mode='carousel' className='arrow' ariaLabel='Previous items' onClick={() => setCurrent(current === 0 ? array.length -size : current -1)} wrapContent={false}><AiOutlineDoubleLeft /></AudioAction>
     : <Clickable className='arrow' onClick={() => setCurrent(current === 0 ? array.length -size : current -1)} ><AiOutlineDoubleLeft /></Clickable>)}
    {array?.map((i,y) => <div key={y} className={`item ${y < current + size && y >= current ? 'visible' : 'hidden'}`}>
        {i}
        </div>)}
     {size < array?.length && (ui === 'v2'
       ? <AudioAction mode='carousel' className='arrow' ariaLabel='Next items' onClick={() => setCurrent(current === array.length -(size) ? 0 : current +1)} wrapContent={false}><AiOutlineDoubleRight /></AudioAction>
       : <Clickable className='arrow' onClick={() => setCurrent(current === array.length -(size) ? 0 : current +1)} ><AiOutlineDoubleRight /></Clickable>)}
  </div>
}

export default Carrousel
